import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Message } from 'src/app/shared/models/message';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { User } from 'src/app/shared/models/security/user';

@Component({
	selector: 'app-mobile-messagerie',
	templateUrl: './mobile-messagerie.component.html',
	styleUrls: ['./mobile-messagerie.component.scss']
})
export class MobileMessagerieComponent implements OnChanges {
	@Input() conversations: Conversation[] = [];
	@Input() notifications: MessageNotification[] = [];
	@Input() isScrollNeeded: boolean = false;
	@Input() isSendButtonDisabled: boolean = false;
	@Input() currentUser: User;
	@Input() usersForNewConversation: User[];
	@Output() sendMessageEmitter: EventEmitter<any> = new EventEmitter();

	@ViewChild('messageContent') messageContentRef: ElementRef;
	@ViewChild('scrolleur') scrolleurElement: ElementRef;

	userReceiver: User;
	convOpen: boolean;
	newConv: boolean = false;

	currentConversationIndex: number;
	messages: Message[] = [];

	constructor(private facadeService: FacadeService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.isScrollNeeded?.currentValue !==
			changes.isScrollNeeded?.previousValue
		) {
			if (changes.isScrollNeeded.currentValue) {
				this.scrollToBottom();
			}
		}
	}

	changeConversation(clickedUser: User): void {
		// L'utilisateur à qui on va envoyé le message (celui sur lequel on a cliqué)
		this.userReceiver = clickedUser;

		// L'id de la conversation
		this.currentConversationIndex = this.conversations.findIndex(
			(conv) => conv.user.id === this.userReceiver.id
		);

		// On retire les notifications liées à l'user sur lequel on a cliqué
		this.notifications = this.notifications.filter(
			(notification) => notification.idSender !== clickedUser.id
		);
		// Et on envoi au back l'ordre de reset le compteur de notification
		this.clearUserNotification();

		// On déclenche l'update automatique des messages de la conversation
		this.facadeService.messageService.ngOnDestroy(); // en détruisant l'ancienne update auto (lié à l'ancien user)
		this.updateConversationAndReload(this.userReceiver);
	}

	clearUserNotification() {
		this.facadeService.notificationService
			.clearMessageNotification(this.userReceiver.id, this.currentUser.id)
			.subscribe(() => {});
	}

	updateConversationAndReload(userReceiver) {
		if (userReceiver !== null) {
			this.facadeService.messageService
				.getAllMessageByIdSenderAndIdReceiverReload(
					this.currentUser.id,
					userReceiver.id
				)
				.subscribe((messagesList: Message[]) => {
					this.messages = messagesList;
				});
		}
	}

	detectOpenConv($event) {
		this.convOpen = $event;
	}

	receiveNewConvAction($event) {
		this.newConv = $event;
	}

	receiveNewConvClose($event) {
		this.newConv = $event;
	}

	backToConvList() {
		this.convOpen = false;
	}

	closeModal() {
		let modal = document.getElementById('exampleModal');
		modal.style.display = 'none';
	}

	scrollToBottom(): void {
		try {
			this.scrolleurElement.nativeElement.scroll({
				top: this.scrolleurElement.nativeElement.scrollHeight,
				left: 0,
				behavior: 'smooth'
			});
		} catch (err) {}
	}

	sendMessage(idReceiver: number, messageContent: string) {
		const idSender = this.currentUser.id;
		if (messageContent.trim() !== '') {
			const message = new Message({
				idSender,
				idReceiver,
				messageContent,
				createdAt: new Date()
			});

			this.sendMessageEmitter.emit({
				conversationId: this.currentConversationIndex,
				message: message
			});

			this.messageContentRef.nativeElement.value = '';
		}
	}

	/**
	 * Le message a bien été reçu par le back end, on peut l'ajouter à la liste des messages
	 * @param message
	 */
	messageReachedBackConfirmed(message: Message) {
		this.messages.push(message);
	}
}
